/**
 * Stores pending log events
 * @module
 */

var _ = require('optimizely-client-fn');

var actionTypes = require('../constants/action_types');
var JSONEnv = require('../lib/json');

/**
 * @constant
 * Maximum number of events to be kept in the store.
 * @type {number}
 */
var PENDING_EVENTS_MAX_LENGTH = 1000;

module.exports = {
  initialize: function() {
    this.__state = {} as any;

    this.on(actionTypes.SET_PENDING_EVENT, this.__setEvent);
    this.on(actionTypes.REMOVE_PENDING_EVENT, this.__removeEvent);
    this.on(actionTypes.LOAD_PENDING_EVENTS, this.__loadEvents);
  },

  /**
   * Return the state of the store - all pending events
   */
  getEvents: function() {
    return this.__state;
  },

  /**
   * @return {string} JSONEnv.stringify'd state
   */
  getEventsString: function(): string {
    return JSONEnv.stringify(this.__state);
  },

  /**
   * Add or update the event in the store
   * @param {Object} payload
   * @property {string} payload.id
   * @property {number} payload.timeStamp
   * @property {Object} payload.data
   * @property {number} payload.retryCount
   * @private
   */
  __setEvent: function(payload:any) {
    // Make sure we don't add too many events to the store.
    if (_.keys(this.__state).length >= PENDING_EVENTS_MAX_LENGTH) {
      this.__cleanStore();
    }

    var eventId = payload.id;
    var retryCount = payload.retryCount;

    // Don't add duplicate events (if event is tried more than once, replace the old one)
    if (!this.__state[eventId] || this.__state[eventId].retryCount !== retryCount) {
      this.__state[eventId] = {
        id: eventId,
        timeStamp: payload.timeStamp,
        data: payload.data,
        retryCount: retryCount,
      };
      this.emitChange();
    }
  },

  /**
   * @param {Object} payload
   * @property {string} payload.id
   * @private
   */
  __removeEvent: function(payload:any) {
    delete this.__state[payload.id];
    this.emitChange();
  },

  /**
   * @param {Object} payload
   * @property {Object} payload.events
   * @private
   */
  __loadEvents: function(payload:any) {
    this.__state = payload.events;
    this.__cleanStore();
    this.emitChange();
  },

  /**
   * Ensures that there are no more than 1000 items in the store, because it's synced with local storage.
   * @private
   */
  __cleanStore: function() {
    var sortableEvents = _.sortBy(this.__state, 'timeStamp');

    for (var i = 0; i <= sortableEvents.length - PENDING_EVENTS_MAX_LENGTH; i++) {
      delete this.__state[sortableEvents[i].id];
    }
    this.emitChange();
  },
};

if (__TEST__) {
  exports.__cleanStore = module.exports.__cleanStore;
}
